import { render, staticRenderFns } from "./MultiQuote.vue?vue&type=template&id=10ca81ae&scoped=true&"
import script from "./MultiQuote.vue?vue&type=script&lang=js&"
export * from "./MultiQuote.vue?vue&type=script&lang=js&"
import style0 from "./MultiQuote.vue?vue&type=style&index=0&id=10ca81ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ca81ae",
  null
  
)

export default component.exports